import { render } from "./SignupFlow.vue?vue&type=template&id=86219b12&scoped=true"
import script from "./SignupFlow.vue?vue&type=script&lang=js"
export * from "./SignupFlow.vue?vue&type=script&lang=js"

import "./SignupFlow.vue?vue&type=style&index=0&id=86219b12&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86219b12"]])

export default __exports__